"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.responseSchema = exports.requestSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const shared_types_1 = require("../../shared-types");
const scheduledEvent = zod_1.default.object({
    eventId: zod_1.default.number().optional(),
    pulseEventId: zod_1.default.number().optional(),
});
exports.requestSchema = zod_1.default.array(scheduledEvent);
const scheduledEventOutputSchema = shared_types_1.IrrigationScheduler.scheduledEventInputSchema.extend({
    status: shared_types_1.IrrigationScheduler.eventStatusSchema,
    pulseEventId: zod_1.default.number().optional(),
});
// TODO: we don't need to do this in Zod
exports.responseSchema = zod_1.default.array(scheduledEventOutputSchema);
exports.path = '/irrigation-scheduler-events-delete';
//# sourceMappingURL=index.js.map